import ExternalComponent from './ExternalComponent'
import RemoteComponent from './RemoteComponent'

export default ExternalComponent
export {RemoteComponent}
